import type React from 'react';
import { createContext } from 'react';

export interface CrispContextValue {
	setShowLauncher: React.Dispatch<React.SetStateAction<boolean>>;
	handleOpenLauncher: (ev?: React.MouseEvent) => void;
}

export default createContext<CrispContextValue>(undefined!);
